export default "__VITE_ASSET__CLfH8B80__"